import { Emblem, type EmblemName } from '../ui/brand/Emblems'
import { cx } from '../ui'
import type { SystemMessage } from './ShellContext'

const EMBLEM: Record<SystemMessage['kind'], EmblemName> = { loading: 'system.loading', transition: 'map.travel', error: 'system.error' }

/** One line above the HUD: loading, travel, errors with «Повторить». */
export function SystemStrip({ message }: { message: SystemMessage | null }) {
  // The live region stays mounted so screen readers announce changes.
  return (
    <div className="system-host" role="status">
      {message && (
        <div className={cx('system slab', `system--${message.kind}`)} role={message.kind === 'error' ? 'alert' : undefined}>
          <Emblem name={EMBLEM[message.kind]} size={18} />
          <span>{message.text}{message.detail && <>: <b>{message.detail}</b></>}</span>
          {message.onRetry && <button type="button" className="system__retry" onClick={message.onRetry}>Повторить</button>}
        </div>
      )}
    </div>
  )
}
